module.exports = function (e) {
  var t = {};

  function r(o) {
    if (t[o]) return t[o].exports;
    var i = t[o] = {
      i: o,
      l: !1,
      exports: {}
    };
    return e[o].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, o) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: o
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var o = Object.create(null);
    if (r.r(o), Object.defineProperty(o, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var i in e) {
      r.d(o, i, function (t) {
        return e[t];
      }.bind(null, i));
    }
    return o;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 1);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  "use strict";

  r.r(t), r.d(t, "GliderComponent", function () {
    return l;
  });

  var _o,
      i = r(0),
      s = (_o = function o(e, t) {
    return (_o = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var r in t) {
        t.hasOwnProperty(r) && (e[r] = t[r]);
      }
    })(e, t);
  }, function (e, t) {
    function r() {
      this.constructor = e;
    }

    _o(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
  }),
      _n = function n() {
    return (_n = Object.assign || function (e) {
      for (var t, r = 1, o = arguments.length; r < o; r++) {
        for (var i in t = arguments[r]) {
          Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  r(2);

  var l = function (e) {
    function t(t) {
      var r = e.call(this, t) || this;
      return r.glider = null, r.gliderInstance = null, r.arrowNext = null, r.arrowNext = null, r.dots = null, r.setGliderRef = function (e) {
        r.glider = e;
      }, r.setArrowPrevRef = function (e) {
        r.arrowPrev = e;
      }, r.setArrowNextRef = function (e) {
        r.arrowNext = e;
      }, r.setDotsRef = function (e) {
        r.dots = e;
      }, r.createGlider = function () {
        r.glider && (r.gliderInstance = new Glider(r.glider, _n({
          arrows: r.props.hasArrows ? r.props.arrows || {
            prev: r.arrowPrev,
            next: r.arrowNext
          } : void 0,
          dots: r.props.hasDots ? r.props.dots || r.dots : void 0
        }, r.props.settings)));
      }, r;
    }

    return s(t, e), t.prototype.componentWillUpdate = function (e) {
      this.gliderInstance && (this.gliderInstance.setOption(_n({
        arrows: e.hasArrows ? e.arrows || {
          prev: this.arrowPrev,
          next: this.arrowNext
        } : void 0,
        dots: e.hasDots ? e.dots || this.dots : void 0
      }, e.settings)), this.gliderInstance.refresh(!0));
    }, t.prototype.componentDidMount = function () {
      var e = this;
      this.createGlider();

      var t = function t(_t, r) {
        "function" == typeof r && e.glider && e.glider.addEventListener(_t, r);
      };

      t("glider-loaded", this.props.gliderLoaded), t("glider-refresh", this.props.gliderRefresh), t("glider-animated", this.props.gliderAnimated), t("glider-add", this.props.gliderAdd), t("glider-remove", this.props.gliderRemove), t("glider-destroy", this.props.gliderDestroy), t("glider-slide-visible", this.props.gliderSlideVisible), t("glider-slide-hidden", this.props.gliderSlideHidden);
    }, t.prototype.componentWillUnmount = function () {
      var e = this,
          t = function t(_t2, r) {
        "function" == typeof r && e.glider && e.glider.removeEventListener(_t2, r);
      };

      t("glider-loaded", this.props.gliderLoaded), t("glider-refresh", this.props.gliderRefresh), t("glider-animated", this.props.gliderAnimated), t("glider-add", this.props.gliderAdd), t("glider-remove", this.props.gliderRemove), t("glider-destroy", this.props.gliderDestroy), t("glider-slide-visible", this.props.gliderSlideVisible), t("glider-slide-hidden", this.props.gliderSlideHidden);
    }, t.prototype.render = function () {
      return i.createElement("div", {
        className: "glider-contain"
      }, i.createElement("div", {
        className: "glider",
        ref: this.setGliderRef
      }, this.props.children), this.props.hasArrows && !this.props.arrows && i.createElement("button", {
        role: "button",
        "aria-label": "Previous",
        className: "glider-prev",
        ref: this.setArrowPrevRef
      }, "«"), this.props.hasArrows && !this.props.arrows && i.createElement("button", {
        role: "button",
        "aria-label": "Next",
        className: "glider-next",
        ref: this.setArrowNextRef
      }, "»"), this.props.hasDots && !this.props.dots && i.createElement("div", {
        role: "tablist",
        className: "dots",
        ref: this.setDotsRef
      }));
    }, t;
  }(i.Component);

  t.default = l;
}, function (e, t, r) {
  var o, i;
  /* @preserve
      _____ __ _     __                _
     / ___// /(_)___/ /___  ____      (_)___
    / (_ // // // _  // -_)/ __/_    / /(_-<
    \___//_//_/ \_,_/ \__//_/  (_)__/ //___/
                                |___/
  
    Version: 1.6.6
    Author: Nick Piscitelli (pickykneee)
    Website: https://nickpiscitelli.com
    Documentation: http://nickpiscitelli.github.io/Glider.js
    License: MIT License
    Release Date: October 25th, 2018
  
  */

  void 0 === (i = "function" == typeof (o = function o() {
    var e = "undefined" != typeof window ? window : this,
        t = e.Glider = function (t, r) {
      var o = this;
      if (t._glider) return t._glider;
      if (o.ele = t, o.ele.classList.add("glider"), (o.ele._glider = o).opt = Object.assign({}, {
        slidesToScroll: 1,
        slidesToShow: 1,
        resizeLock: !0,
        duration: .5,
        easing: function easing(e, t, r, o, i) {
          return o * (t /= i) * t + r;
        }
      }, r), o.animate_id = o.page = o.slide = 0, o.arrows = {}, o._opt = o.opt, o.opt.skipTrack) o.track = o.ele.children[0];else for (o.track = document.createElement("div"), o.ele.appendChild(o.track); 1 !== o.ele.children.length;) {
        o.track.appendChild(o.ele.children[0]);
      }
      o.track.classList.add("glider-track"), o.init(), o.resize = o.init.bind(o, !0), o.event(o.ele, "add", {
        scroll: o.updateControls.bind(o)
      }), o.event(e, "add", {
        resize: o.resize
      });
    },
        r = t.prototype;

    return r.init = function (e, t) {
      var r = this,
          o = 0,
          i = 0;
      r.slides = r.track.children, [].forEach.call(r.slides, function (e) {
        e.classList.add("glider-slide");
      }), r.containerWidth = r.ele.clientWidth;
      var s = r.settingsBreakpoint();

      if (t || (t = s), "auto" === r.opt.slidesToShow || r.opt._autoSlide) {
        var n = r.containerWidth / r.opt.itemWidth;
        r.opt._autoSlide = r.opt.slidesToShow = r.opt.exactWidth ? n : Math.floor(n);
      }

      "auto" === r.opt.slidesToScroll && (r.opt.slidesToScroll = Math.floor(r.opt.slidesToShow)), r.itemWidth = r.opt.exactWidth ? r.opt.itemWidth : r.containerWidth / r.opt.slidesToShow, [].forEach.call(r.slides, function (e) {
        e.style.height = "auto", e.style.width = r.itemWidth + "px", o += r.itemWidth, i = Math.max(e.offsetHeight, i);
      }), r.track.style.width = o + "px", r.trackWidth = o, r.opt.resizeLock && r.scrollTo(r.slide * r.itemWidth, 0), (s || t) && (r.bindArrows(), r.buildDots(), r.bindDrag()), r.updateControls(), r.emit(e ? "refresh " : "loaded");
    }, r.bindDrag = function () {
      var e = this;
      e.mouse = e.mouse || e.handleMouse.bind(e);

      var t = function t() {
        e.mouseDown = void 0, e.ele.classList.remove("drag");
      },
          r = {
        mouseup: t,
        mouseleave: t,
        mousedown: function mousedown(t) {
          e.mouseDown = t.clientX, e.ele.classList.add("drag");
        },
        mousemove: e.mouse
      };

      e.ele.classList.toggle("draggable", !0 === e.opt.draggable), e.event(e.ele, "remove", r), e.opt.draggable && e.event(e.ele, "add", r);
    }, r.buildDots = function () {
      var e = this;

      if (e.opt.dots) {
        if ("string" == typeof e.opt.dots ? e.dots = document.querySelector(e.opt.dots) : e.dots = e.opt.dots, e.dots) {
          e.dots.innerHTML = "", e.dots.className = "glider-dots";

          for (var t = 0; t < Math.ceil(e.slides.length / e.opt.slidesToShow); ++t) {
            var r = document.createElement("button");
            r.dataset.index = t, r.setAttribute("aria-label", "Page " + (t + 1)), r.className = "glider-dot " + (t ? "" : "active"), e.event(r, "add", {
              click: e.scrollItem.bind(e, t, !0)
            }), e.dots.appendChild(r);
          }
        }
      } else e.dots && (e.dots.innerHTML = "");
    }, r.bindArrows = function () {
      var e = this;
      e.opt.arrows ? ["prev", "next"].forEach(function (t) {
        var r = e.opt.arrows[t];
        r && ("string" == typeof r && (r = document.querySelector(r)), r._func = r._func || e.scrollItem.bind(e, t), e.event(r, "remove", {
          click: r._func
        }), e.event(r, "add", {
          click: r._func
        }), e.arrows[t] = r);
      }) : Object.keys(e.arrows).forEach(function (t) {
        var r = e.arrows[t];
        e.event(r, "remove", {
          click: r._func
        });
      });
    }, r.updateControls = function (e) {
      var t = this;
      e && !t.opt.scrollPropagate && e.stopPropagation();
      var r = t.containerWidth >= t.trackWidth;
      t.opt.rewind || (t.arrows.prev && t.arrows.prev.classList.toggle("disabled", t.ele.scrollLeft <= 0 || r), t.arrows.next && t.arrows.next.classList.toggle("disabled", t.ele.scrollLeft + t.containerWidth >= Math.floor(t.trackWidth) || r)), t.slide = Math.round(t.ele.scrollLeft / t.itemWidth), t.page = Math.round(t.ele.scrollLeft / t.containerWidth);
      var o = t.slide + Math.floor(Math.floor(t.opt.slidesToShow) / 2),
          i = Math.floor(t.opt.slidesToShow) % 2 ? 0 : o + 1;
      1 === Math.floor(t.opt.slidesToShow) && (i = 0), t.ele.scrollLeft + t.containerWidth >= Math.floor(t.trackWidth) && (t.page = t.dots ? t.dots.children.length - 1 : 0), [].forEach.call(t.slides, function (e, r) {
        var s = e.classList,
            n = s.contains("visible"),
            l = t.ele.scrollLeft,
            a = t.ele.scrollLeft + t.containerWidth,
            d = t.itemWidth * r,
            c = d + t.itemWidth;
        [].forEach.call(s, function (e) {
          /^left|right/.test(e) && s.remove(e);
        }), s.toggle("active", t.slide === r), o === r || i && i === r ? s.add("center") : (s.remove("center"), s.add([r < o ? "left" : "right", Math.abs(r - (r < o ? o : i || o))].join("-")));
        var p = Math.ceil(d) >= l && Math.floor(c) <= a;
        s.toggle("visible", p), p !== n && t.emit("slide-" + (p ? "visible" : "hidden"), {
          slide: r
        });
      }), t.dots && [].forEach.call(t.dots.children, function (e, r) {
        e.classList.toggle("active", t.page === r);
      }), e && t.opt.scrollLock && (clearTimeout(t.scrollLock), t.scrollLock = setTimeout(function () {
        clearTimeout(t.scrollLock), t.ele.scrollLeft / t.itemWidth % 1 && t.scrollItem(t.round(t.ele.scrollLeft / t.itemWidth));
      }, t.opt.scrollLockDelay || 250));
    }, r.scrollItem = function (e, t, r) {
      r && r.preventDefault();
      var o = this,
          i = e;
      if (++o.animate_id, !0 === t) e *= o.containerWidth, e = Math.round(e / o.itemWidth) * o.itemWidth;else {
        if ("string" == typeof e) {
          var s = "prev" === e;

          if (e = o.opt.slidesToScroll % 1 || o.opt.slidesToShow % 1 ? o.round(o.ele.scrollLeft / o.itemWidth) : o.slide, s ? e -= o.opt.slidesToScroll : e += o.opt.slidesToScroll, o.opt.rewind) {
            var n = o.ele.scrollLeft;
            e = s && !n ? o.slides.length : !s && n + o.containerWidth >= Math.floor(o.trackWidth) ? 0 : e;
          }
        }

        e = Math.max(Math.min(e, o.slides.length), 0), o.slide = e, e = o.itemWidth * e;
      }
      return o.scrollTo(e, o.opt.duration * Math.abs(o.ele.scrollLeft - e), function () {
        o.updateControls(), o.emit("animated", {
          value: i,
          type: "string" == typeof i ? "arrow" : t ? "dot" : "slide"
        });
      }), !1;
    }, r.settingsBreakpoint = function () {
      var t = this,
          r = t._opt.responsive;

      if (r) {
        r.sort(function (e, t) {
          return t.breakpoint - e.breakpoint;
        });

        for (var o = 0; o < r.length; ++o) {
          var i = r[o];
          if (e.innerWidth >= i.breakpoint) return t.breakpoint !== i.breakpoint && (t.opt = Object.assign({}, t._opt, i.settings), t.breakpoint = i.breakpoint, !0);
        }
      }

      var s = 0 !== t.breakpoint;
      return t.opt = Object.assign({}, t._opt), t.breakpoint = 0, s;
    }, r.scrollTo = function (t, r, o) {
      var i = this,
          s = new Date().getTime(),
          n = i.animate_id,
          l = function l() {
        var a = new Date().getTime() - s;
        i.ele.scrollLeft = i.ele.scrollLeft + (t - i.ele.scrollLeft) * i.opt.easing(0, a, 0, 1, r), a < r && n === i.animate_id ? e.requestAnimationFrame(l) : (i.ele.scrollLeft = t, o && o.call(i));
      };

      e.requestAnimationFrame(l);
    }, r.removeItem = function (e) {
      var t = this;
      t.slides.length && (t.track.removeChild(t.slides[e]), t.refresh(!0), t.emit("remove"));
    }, r.addItem = function (e) {
      this.track.appendChild(e), this.refresh(!0), this.emit("add");
    }, r.handleMouse = function (e) {
      var t = this;
      t.mouseDown && (t.ele.scrollLeft += (t.mouseDown - e.clientX) * (t.opt.dragVelocity || 3.3), t.mouseDown = e.clientX);
    }, r.round = function (e) {
      var t = 1 / (this.opt.slidesToScroll % 1 || 1);
      return Math.round(e * t) / t;
    }, r.refresh = function (e) {
      this.init(!0, e);
    }, r.setOption = function (e, t) {
      var r = this;
      r.breakpoint && !t ? r._opt.responsive.forEach(function (t) {
        t.breakpoint === r.breakpoint && (t.settings = Object.assign({}, t.settings, e));
      }) : r._opt = Object.assign({}, r._opt, e), r.breakpoint = 0, r.settingsBreakpoint();
    }, r.destroy = function () {
      var t = this,
          r = t.ele.cloneNode(!0),
          o = function o(e) {
        e.removeAttribute("style"), [].forEach.call(e.classList, function (t) {
          /^glider/.test(t) && e.classList.remove(t);
        });
      };

      r.children[0].outerHTML = r.children[0].innerHTML, o(r), [].forEach.call(r.getElementsByTagName("*"), o), t.ele.parentNode.replaceChild(r, t.ele), t.event(e, "remove", {
        resize: t.resize
      }), t.emit("destroy");
    }, r.emit = function (t, r) {
      var o = new e.CustomEvent("glider-" + t, {
        bubbles: !this.opt.eventPropagate,
        detail: r
      });
      this.ele.dispatchEvent(o);
    }, r.event = function (e, t, r) {
      var o = e[t + "EventListener"].bind(e);
      Object.keys(r).forEach(function (e) {
        o(e, r[e]);
      });
    }, t;
  }) ? o.call(t, r, t, e) : o) || (e.exports = i);
}]);